module.exports = __webpack_public_path__ + "static/media/bgPattern.e3821d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgPattern.png
// module id = 173
// module chunks = 0